import { useSelector } from "react-redux";
import { selectIsOnline } from "../../../store/slices/network";
import { RootState } from "../../../services/store";
import { selectResidentFluidIntakeLogs } from "../../../store/slices/fluidIntake";
import { useFluidIntakeHistoryQuery } from "../../../services/api/staticFormsApi";
import { useMemo } from "react";

interface Props {
  residentId?: number;
  currentPage: number;
  handlePageChange: (page: number) => void;
}

export function useFluidIntakeWithOffline({
  residentId,
  currentPage,
  handlePageChange,
}: Props) {
  const isOnline = useSelector(selectIsOnline);

  const offlineData = useSelector((state: RootState) =>
    selectResidentFluidIntakeLogs(state, residentId),
  );

  const {
    data: onlineData,
    isFetching,
    isError,
  } = useFluidIntakeHistoryQuery(
    { filter: { resident_id: residentId }, page: currentPage },
    { skip: !residentId },
  );

  const data = useMemo(() => {
    if (isFetching || isOnline) return onlineData?.data;
    if (isError && offlineData) return offlineData;
    return onlineData?.data;
  }, [onlineData, offlineData, isOnline, isFetching, isError]);

  return { data, meta: onlineData?.meta, isFetching, handlePageChange };
}
